"use strict";const emotionCSS=require("@emotion/css").default;const{pwop}=require("@pwops/core");exports.css=obj=>emotionCSS(pwop(obj));